module.exports = __webpack_public_path__ + "Upsell_Insights_Light.5851b63157dc97ea5019f0b7d1ad8faa.hashedasset.svg";